/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'trash': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<path pid="0" d="M2.007 13.325a.705.705 0 00.704.675H9.29a.705.705 0 00.704-.675l.47-9.916H1.537l.47 9.916zm5.48-7.453c0-.158.129-.286.287-.286h.458c.158 0 .286.128.286.286v5.665a.286.286 0 01-.286.286h-.458a.286.286 0 01-.286-.286V5.872zm-2.002 0c0-.158.128-.286.286-.286h.458c.158 0 .286.128.286.286v5.665a.286.286 0 01-.286.286H5.77a.286.286 0 01-.286-.286V5.872zm-2.003 0c0-.158.128-.286.286-.286h.458c.158 0 .286.128.286.286v5.665a.286.286 0 01-.286.286h-.458a.286.286 0 01-.286-.286V5.872zM10.775.721H7.741V.148A.148.148 0 007.593 0H4.407a.148.148 0 00-.148.148V.72H1.225a.442.442 0 00-.442.442v1.39h10.434v-1.39a.442.442 0 00-.442-.442z" _fill="#6D9AE8"/>'
  }
})
